<template>
    <div class="share-report-container">
        <div class="banner" :class="{ family: memberList.length > 1 }"></div>
        <div class="family-report-wrapper">
            <div
                class="member-report-wrapper"
                v-for="(item, index) in memberList"
                :key="index"
            >
                <div class="radar-chart-container">
                    <div class="radar-title-wrapper">
                        <p class="title">{{ item.name }}的保障分析报告</p>
                        <div class="idol-wrapper">
                            <span class="chart-idol">目前保障</span>
                            <span class="chart-idol green">应有保障</span>
                        </div>
                    </div>
                    <div class="radar-chart-wrapper">
                        <canvas
                            :ref="'canvas' + index"
                            :id="'radar-chart' + index"
                            class="radar-chart"
                        ></canvas>
                    </div>
                </div>
                <div class="current-risk-wrapper">
                    <p class="title">目前风险</p>
                    <div
                        class="risk-item-wrapper serious"
                        v-show="riskShow('serious', item.relation)"
                    >
                        <div class="header">
                            <span class="icon"></span>
                            <p class="label">重疾风险</p>
                            <p class="text">风险紧急度</p>
                            <star-rate
                                :num="item.emergencyLevel.seriousEmergency"
                                color="yellow"
                            ></star-rate>
                        </div>
                        <p
                            class="desc-text"
                            v-html="seriousRange(item.gender, item.age)"
                        ></p>
                    </div>
                    <div
                        class="risk-item-wrapper accident"
                        v-show="riskShow('accident', item.relation)"
                    >
                        <div class="header">
                            <span class="icon"></span>
                            <p class="label">身故风险</p>
                            <p class="text">风险紧急度</p>
                            <star-rate
                                :num="item.emergencyLevel.diedEmergency"
                            ></star-rate>
                        </div>
                        <p class="desc-text">
                            身故导致经济收入中断，突发性的意外身故更会导致家人受到重创。面对自己应承担的父母赡养等责任，身故风险给家人带来的打击无疑是毁灭性的。<span
                                v-if="item.gender == 0"
                                ><br />据《中国保险人群意外伤害风险研究报告》调查显示，男性的总体意外伤害风险约为女性的1.3倍，尤其是中青年(20岁-59岁)阶段，男性意外伤害风险更是女性的2.38倍。</span
                            >
                        </p>
                    </div>
                    <div
                        class="risk-item-wrapper life"
                        v-show="riskShow('life', item.relation)"
                    >
                        <div class="header">
                            <span class="icon"></span>
                            <p class="label">养老风险</p>
                            <p class="text">风险紧急度</p>
                            <star-rate
                                :num="item.emergencyLevel.pensionEmergency"
                            ></star-rate>
                        </div>
                        <p class="desc-text">
                            我国的养老金替代率下降趋势明显，为了保证老年的生活品质和医疗所需的费用缺口，需要保证长期、可预期的现金流。我们建议，在收入到达一定水平后，将一部分收入用于购买养老险，未雨绸缪，合理规划退休生活。
                        </p>
                    </div>
                    <div
                        class="risk-item-wrapper inherited"
                        v-show="riskShow('inherited', item.relation)"
                    >
                        <div class="header">
                            <span class="icon"></span>
                            <p class="label">传承风险</p>
                            <p class="text">风险紧急度</p>
                            <star-rate
                                :num="item.emergencyLevel.inheritedEmergency"
                                color="green"
                            ></star-rate>
                        </div>
                        <p class="desc-text">
                            在各种人生不确定因素的影响下，我们都希望子女教育有规划，家庭财富可传承，可灵活调配、又可稳定增长的现金流，显得尤其重要。
                        </p>
                    </div>
                </div>
                <div class="product-rate-wrapper">
                    <div class="rate-wrapper">
                        <h3 class="title">
                            结合您{{ nickName(item.name) }}的已有产品保障，您{{
                                nickName(item.name)
                            }}的
                        </h3>
                        <p class="param serious">
                            重疾保障充足度 —— {{ rateRender(item, "serious") }}
                        </p>
                        <p class="param accident">
                            意外保障充足度 —— {{ rateRender(item, "accident") }}
                        </p>
                        <p class="param medical">
                            医疗保障充足度 —— {{ rateRender(item, "medical") }}
                        </p>
                        <p class="param life">
                            寿险保障充足度 —— {{ rateRender(item, "life") }}
                        </p>
                    </div>
                    <template v-if="item.relation == '03'">
                        <p class="text">
                            建议您的{{ nickName(item.name) }}优先补充完善<span
                                class="blue"
                                >重疾、医疗产品</span
                            >。
                        </p>
                    </template>
                    <template v-else>
                        <p class="text">
                            建议您{{ item.relation == "00" ? "" : "的"
                            }}{{ nickName(item.name) }}优先补充完善<span
                                class="blue"
                                >重疾、意外、医疗保障型产品</span
                            >，弥补当前的人身风险。
                        </p>
                        <p class="text">
                            待当前的风险得到完善后，尽早补充<span class="blue"
                                >寿险、养老、传承。</span
                            >
                        </p>
                    </template>
                </div>
            </div>
        </div>
        <a href="javascript:;" class="share-btn" @click="shareReport"
            >分享报告</a
        >
    </div>
</template>
<script>
import mixin from "@/utils/riskReportMixin.js";
import share from "cignacmb-share";
import getShareParams from "@/utils/getShareParams.js";
import StarRate from "@/components/star-rate/StarRate.vue";
export default {
    props: ["id"],
    mixins: [mixin],
    created() {
        this.repaintEvent = (e) => {
            setTimeout(() => {
                for (let index = 0; index < this.memberList.length; index++) {
                    this.parseChartData(this.memberList[index]);
                    this.renderChart("canvas" + index);
                }
            }, 20);
        };
    },
    mounted() {
        for (let index = 0; index < this.memberList.length; index++) {
            this.parseChartData(this.memberList[index]);
            this.renderChart("canvas" + index);
        }
    },
    methods: {
        seriousRange(gender, age) {
            let res = this.seriousLabel.find((item) => {
                return (
                    age >= item.min && age <= item.max && item.gender == gender
                );
            });
            return res.desc;
        },
        shareReport() {
            if (this.id) {
                share(getShareParams({ id: this.id }), { withGiude: true });
            } else {
                this.$http({
                    loading: true,
                    url: "/bdzb-core-service/report/saveRemark",
                    data: {
                        remark: JSON.stringify(this.data),
                    },
                    method: "POST",
                }).then((res) => {
                    share(getShareParams({ id: res.id }), { withGiude: true });
                });
            }
        },
        rateRender(item, type) {
            let deno = item.shouldGuaranteed[type];
            let member = item.guaranteeds[type];
            let rate =
                deno == 0 ? "100%" : ((member / deno) * 100).toFixed(2) + "%";
            return rate;
        },
        nickName(name) {
            return name == "您" ? "" : name;
        },
    },
    components: {
        StarRate,
    },
};
</script>
<style scoped>
.share-report-container {
    position: relative;
    background: #eef6ff;
    overflow: hidden;
}
.banner {
    position: absolute;
    width: 100%;
    height: 1.57rem;
    background-image: url(./images/banner.png);
    background-size: 100%;
}
.banner.family {
    background-image: url(./images/banner-family.png);
}
.family-report-wrapper {
    position: relative;
    margin-top: 1rem;
}
.family-report-wrapper {
}
.radar-chart-container {
    margin: 0 0.15rem 0.15rem;
    padding-bottom: 0.05rem;
    background: #ffffff;
    border-radius: 0.08rem;
    box-shadow: 0px 5px 5px #e0ecfa;
}
.radar-title-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 0.6rem;
    padding: 0 0.15rem;
}
.radar-title-wrapper .title {
    font-size: 0.15rem;
    font-weight: bold;
    color: #0f2742;
}
.radar-title-wrapper .idol-wrapper {
    display: flex;
}
.radar-title-wrapper .chart-idol {
    position: relative;
    padding-left: 0.23rem;
    font-size: 0.11rem;
    line-height: 0.22rem;
    color: #617080;
}
.radar-title-wrapper .chart-idol::before {
    position: absolute;
    content: "";
    left: 0.13rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0.06rem;
    height: 0.06rem;
    background: #e64848;
    border-radius: 50%;
}
.radar-title-wrapper .chart-idol.green::before {
    background: #30c464;
}
.radar-chart-wrapper {
    position: relative;
    height: 2.8rem;
    margin-bottom: 0.1rem;
}
.radar-chart-wrapper .radar-chart {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
}
.current-risk-wrapper {
    position: relative;
    background: #fff;
}
.current-risk-wrapper .title {
    height: 0.44rem;
    line-height: 0.44rem;
    padding: 0 0.15rem;
    font-size: 0.17rem;
    font-weight: bold;
    color: #0f2742;
    border-bottom: 1px solid #eff0f2;
}
.risk-item-wrapper {
    margin: 0.23rem 0.15rem 0.2rem;
    border-bottom: 1px dashed #eef6ff;
}
.risk-item-wrapper:last-child {
    border-bottom: none;
    margin-bottom: 0;
}
.risk-item-wrapper .header {
    display: flex;
    align-items: center;
}
.risk-item-wrapper .icon {
    width: 0.38rem;
    height: 0.38rem;
    background-image: url(./images/serious-icon.png);
    background-size: 100%;
}
.risk-item-wrapper.accident .icon {
    background-image: url(./images/accident-icon.png);
}
.risk-item-wrapper.life .icon {
    background-image: url(./images/life-icon.png);
}
.risk-item-wrapper.inherited .icon {
    background-image: url(./images/inherited-icon.png);
}
.risk-item-wrapper .label {
    position: relative;
    margin-left: 0.15rem;
    margin-right: 0.3rem;
    font-size: 0.14rem;
    color: #0f2742;
}
.risk-item-wrapper .label::after {
    position: absolute;
    content: "";
    height: 0.04rem;
    background: #c6c6c6;
    opacity: 0.6;
    border-radius: 0.01rem;
    left: -0.02rem;
    right: -0.02rem;
    bottom: -0.01rem;
}
.risk-item-wrapper .text {
    font-size: 0.12rem;
    color: #617080;
}
.risk-item-wrapper .desc-text {
    padding-left: 0.53rem;
    padding-bottom: 0.2rem;
    font-size: 0.13rem;
    color: #617080;
    line-height: 0.21rem;
}
.product-rate-wrapper {
    padding: 0.23rem 0.15rem;
    background: #fff;
    border-top: 1px solid #eff0f2;
    margin-bottom: 0.15rem;
}
.product-rate-wrapper .rate-wrapper {
    position: relative;
    width: 2.6rem;
    height: 1.46rem;
    padding-left: 0.24rem;
    margin-bottom: 0.25rem;
    border: 1px solid #afd4ff;
    border-radius: 0.09rem;
    background: #f0f7ff;
}
.product-rate-wrapper .rate-wrapper::after {
    content: "";
    position: absolute;
    width: 0.83rem;
    height: 0.83rem;
    bottom: -0.18rem;
    right: -0.54rem;
    background-image: url(./images/advise-robot.png);
    background-size: 100%;
}
.product-rate-wrapper .title {
    margin-top: 0.2rem;
    margin-bottom: 0.08rem;
    font-size: 0.13rem;
    color: #0f2742;
}
.product-rate-wrapper .param {
    position: relative;
    padding-left: 0.18rem;
    font-size: 0.12rem;
    color: #0f2742;
    line-height: 1.8;
}
.product-rate-wrapper .param::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 0.04rem;
    height: 0.04rem;
    background: #f06868;
    border-radius: 50%;
}
.product-rate-wrapper .param.accident::before {
    background: #ff947b;
}
.product-rate-wrapper .param.medical::before {
    background: #6ed2ae;
}
.product-rate-wrapper .param.life::before {
    background: #8e84ed;
}
.product-rate-wrapper .text {
    margin-bottom: 0.05rem;
    font-size: 0.13rem;
    color: #0f2742;
}
.product-rate-wrapper .text .blue {
    color: #3b97ff;
}
.share-report-container .share-btn {
    display: block;
    height: 0.48rem;
    line-height: 0.48rem;
    font-size: 0.16rem;
    font-weight: bold;
    text-align: center;
    color: #fff;
    background-color: #3b97ff;
}
</style>
